module.exports = __webpack_public_path__ + "01_mustache_brown.ae7ef798.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/01_mustache_brown.png
// module id = 6/41
// module chunks = 0